export default __webpack_public_path__ + "static/media/trust.c27cf6cf.png";